"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0b1826",
          color: "#ffffff",
          fontFamily: "system-ui, sans-serif",
          textAlign: "center",
          padding: "2rem",
        }}
      >
        <div>
          <p style={{ color: "#8fd11f", fontSize: 12, letterSpacing: "0.18em" }}>
            CHYBA APLIKACE
          </p>
          <h1 style={{ fontSize: 28, fontWeight: 600, margin: "1rem 0" }}>
            Něco se pokazilo
          </h1>
          <p style={{ color: "rgba(255,255,255,0.7)", maxWidth: 460, margin: "0 auto" }}>
            Omlouváme se za komplikace. Zkuste prosím stránku načíst znovu
            {error.digest ? ` (kód ${error.digest})` : ""}.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: "2rem",
              background: "#4c8700",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "0.75rem 1.5rem",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
